export class Action {
    public id: string;
    public text: string;
    public icon: string;

    constructor(item: Object) {
        Object.keys(item).forEach((prop) => {
            this[prop] = item[prop]
        });
    }
}



// WEBPACK FOOTER //
// ./src/bean/action.ts